import { LoginState, ProductType } from '@xing-com/crate-common-graphql-types';
import { useLocation } from '@xing-com/crate-core-router';
import { useLoginAppUrl } from '@xing-com/crate-xinglet';
import { useLoginState } from '@xing-com/hub';

export type ActivationUrls = Record<ProductType, string>;

const checkoutUrls: ActivationUrls = {
  [ProductType.Premium]: '/purchase/checkout/premium',
  [ProductType.Projobs]: '/purchase/checkout/projobs',
};

export const useActivationUrl = (): ActivationUrls => {
  const loginState = useLoginState();
  const loginAppUrl = useLoginAppUrl();
  const { search } = useLocation();
  const createActivationUrl = (product: ProductType): string => {
    const checkoutUrl = `${checkoutUrls[product]}${search ?? ''}`;

    if (loginState !== LoginState.LoggedOut) {
      return checkoutUrl;
    }

    const loginParameters = new URLSearchParams({
      dest_url: checkoutUrl,
      login_channel: 'upsellfunnel',
    });

    return `${loginAppUrl.replace(/\/$/, '')}/continue?${loginParameters.toString()}`;
  };

  return {
    [ProductType.Premium]: createActivationUrl(ProductType.Premium),
    [ProductType.Projobs]: createActivationUrl(ProductType.Projobs),
  };
};
